/**
 * TikTok Anchor Eligibility Schema
 */
import {z} from 'zod';


/** Types */
export type TikTokAnchorEligibility = z.infer<typeof zTikTokAnchorEligibility>;


/** Constants */
export const zTikTokAnchorEligibility = z.object({
    isEligible: z.boolean(),
    authorizedDomains: z.array(z.url()),
    checkedAt: z.instanceof(Date),
});


/**
 * Checks if a given anchor URL is authorized based on the provided list of authorized domains.
 *
 * @param anchorUrl - The anchor URL to check.
 * @param authorizedDomains - An array of authorized domain URLs.
 * @returns True if the anchor URL is authorized, false otherwise.
 */
export function isTikTokAnchorUrlAuthorized(
    anchorUrl: string,
    authorizedDomains: ReadonlyArray<string>,
): boolean {
    try {
        const candidate = new URL(anchorUrl);
        if (candidate.protocol !== 'https:') return false;
        return authorizedDomains.some((authorizedDomain) => {
            try {
                const authorized = new URL(authorizedDomain);
                return (authorized.protocol === 'https:')
                    && (authorized.hostname.toLowerCase() === candidate.hostname.toLowerCase());
            } catch {
                return false;
            }
        });
    } catch {
        return false;
    }
}
